import { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "../../../../assets/scss/global.scss";
import LoaderImg from "../../../../assets/images/loader.gif";
import { generateQueryString } from "../../../../core/utility/utility";
import { getApiUrl } from "../../../../utils/baseUrl";
import { toast } from "react-toastify";
import { getAccountsUrl } from "../../../../utils/accountsUrl";
import LocalStorageService from "../../../../core/services/local-storage.service";
import { intelHeader } from "../../../../components/layout/accounts-header/account-header";
import { useHistory } from "react-router-dom";
const API_URL = "https://accounts.zoho.com/oauth/v2/auth";
const localStorageService = LocalStorageService.getService();
const REDIRECT_URI = getAccountsUrl() + "user/zoho-status";
const apiEndpoint = {
  validateClientId: getApiUrl("validateClientId"),
  saveZohoClientId: getApiUrl("saveZohoClientId"),
  saveZohoToken: getApiUrl("saveZohoToken"),
  getZohoUserDetails: getApiUrl("getZohoUserDetails"),
};
const ZohoIntegration = (props) => {
  const history = useHistory();
  const [clientFieldID, setFieldClientId] = useState("");
  const [secretFieldCode, setFieldSecretCode] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [redirectSuccess, setRedirectSuccess] = useState(false);
  const { userDetails: { is_zoho_active: isZoho } = {}, setLoader, loader } = props;
  const handleClick = async (data) => {
    setIsEnabled(true);
    const UID = props && props.userDetails && props.userDetails.email ? props.userDetails.email : "";
    const requestObj = { response_type: "code", client_id: data.clientID, redirect_uri: REDIRECT_URI, prompt: "consent", state: UID, access_type: "offline" };
    const saveRequestObj = { client_id: data.clientID, client_secret: data.secretCode, state: UID };
    saveClientInfo(saveRequestObj);
    let tempQueryString = generateQueryString(requestObj);
    if (!!tempQueryString && tempQueryString !== "") {
      tempQueryString = "?" + tempQueryString;
    }
    window.open(API_URL + tempQueryString + "&scope=ZohoCRM.modules.ALL");
    setIsEnabled(false);
  };
  const saveClientInfo = (data) => {
    const params = {
      client_id: data.client_id,
      client_secret: data.client_secret,
      uid: data.state,
    };
    axios.post(apiEndpoint.saveZohoClientId, params).then((res) => {
      if (res && res.data) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    });
  };
  const logout = () => {
    axios.get(intelHeader.logoutUser).then((res) => {
      if (res.data.status.toLowerCase() === "success".toLowerCase()) {
        localStorageService.clearCompleteStorage();
        history.push("signout");
      }
    });
  };
  const verifyToken = (param1, param2) => {
    if (!param1) return;
    const params = {
      code: param1,
      uid: param2 ? param2 : "",
    };
    axios
      .post(apiEndpoint.saveZohoToken, params)
      .then((res) => {
        if (res && res.data && res.data.status.toLowerCase() === "success") {
          toast.success("Your configuration has been saved successfully. Please log in again.");
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => toast.error("Something went wrong! Please try again."));
  };
  const getDetails = () => {
    setLoader(true);
    axios.get(apiEndpoint.getZohoUserDetails).then((res) => {
      if (res && res.data && res.data.data && res.data.data.client_id && res.data.data.client_secret && res.data.data.client_id !== "" && res.data.data.client_secret !== "") {
        setFieldClientId(res.data.data.client_id);
        setFieldSecretCode(res.data.data.client_secret);
        setDisabled(res.data.data.status.toLowerCase() === "complete" ? true : false);
        setRedirectSuccess(res.data.data.status.toLowerCase() === "complete" ? true : false);
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.data.data.message);
      }
    });
  };
  useEffect(() => {
    const searchUrlParams = props.location.search;
    const accountsURL = props.location.pathname;
    if (accountsURL.includes("/zoho-status") && new URLSearchParams(searchUrlParams).get("code") !== "" && new URLSearchParams(searchUrlParams).get("state") !== "") {
      if (props && props.userDetails && props.userDetails.is_admin === false) {
        setDisabled(true);
      }
      setTimeout(function () {
        verifyToken(new URLSearchParams(searchUrlParams).get("code"), new URLSearchParams(searchUrlParams).get("state"));
      }, 100);
    }
    setTimeout(() => {
      getDetails();
    }, 1000);
  }, []);

  return (
    <div className="container">
      {loader && isZoho ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <img src={LoaderImg} alt="description of gif" />
        </div>
      ) : (
        <div className="salesforceContainer">
          <div className="card-body px-0">
            <div className="reset-form w-100">
              <Formik
                initialValues={{
                  clientID: clientFieldID ? clientFieldID : "",
                  secretCode: secretFieldCode ? secretFieldCode : "",
                }}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  clientID: Yup.string().min(6, "Client Id must be at least 6 characters").required("Client Id is required"),
                  secretCode: Yup.string().min(6, "Secret Code must be at least 6 characters").required("Secret Code is required"),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  handleClick(values, setSubmitting);
                }}
                render={({ errors, touched }) => (
                  <Form>
                    <div className="form-group">
                      <label className="col-4 pl-0 client-id-label" htmlFor="clientID">
                        Enter Client Id
                      </label>
                      <Field name="clientID" type="text" disabled={disabled} className={"form-control col-12" + (errors.clientID && touched.clientID ? " is-invalid" : "")} />
                      <ErrorMessage name="clientID" component="div" className="invalid-feedback m-auto px-3" />
                    </div>
                    <div className="form-group">
                      <label className="col-4 pl-0 client-id-label" htmlFor="secretCode">
                        Enter Client Secret
                      </label>
                      <Field
                        name="secretCode"
                        type="text"
                        disabled={disabled}
                        className={`col-12 ${"form-control" + (errors.secretCode && touched.secretCode ? " is-invalid" : "")}`}
                      />
                      <ErrorMessage name="secretCode" component="div" className="invalid-feedback m-auto px-3" />
                    </div>
                    <div className="form-group">
                      <div className="col-12"></div>
                      {!!isEnabled && isEnabled === true ? (
                        <button className="col-12 btn btn-primary btn-change-password w-100" type="button" disabled>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span className="sr-only">Loading...</span>
                        </button>
                      ) : (
                        <button type="submit" className="col-12 btn btn-primary btn-change-password w-100" disabled={disabled}>
                          {redirectSuccess ? "Connected" : "Connect to Zoho"}
                        </button>
                      )}
                    </div>
                  </Form>
                )}
              ></Formik>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ZohoIntegration;
